// "Also works with these locations" on a contact (Stephanie 2026-10-27/28,
// Bozzuto: one person orders for several buildings). Bozzuto has ~430
// locations, so the box searches instead of listing them all. Pure, so the
// offline gate executes what the screen runs.

export interface LinkableAccount {
  id: string;
  name: string;
}

/** The accounts a search offers: the company's main account + locations,
 *  never the contact's home account or ones already picked; matches every
 *  word typed (any order, any case); at most `limit`. Blank search → none. */
export function linkChoices(
  company: { main: LinkableAccount; locations: readonly LinkableAccount[] },
  homeId: string,
  picked: readonly string[],
  query: string,
  limit = 8,
): LinkableAccount[] {
  const words = query.toLowerCase().split(/\s+/).filter(Boolean);
  if (words.length === 0) return [];
  const taken = new Set([homeId, ...picked]);
  const all = [{ id: company.main.id, name: `${company.main.name} (main account)` }, ...company.locations];
  return all
    .filter((a) => !taken.has(a.id))
    .filter((a) => words.every((w) => a.name.toLowerCase().includes(w)))
    .sort((a, b) => a.name.localeCompare(b.name))
    .slice(0, limit);
}

/** Did the picked list change from what's saved (order doesn't matter)? */
export function linksChanged(saved: readonly string[], picked: readonly string[]): boolean {
  const a = new Set(saved);
  const b = new Set(picked);
  return a.size !== b.size || [...a].some((id) => !b.has(id));
}
